
  import { defineComponent, onMounted, ref, watch } from 'vue';

  export default defineComponent({
    name: 'Range',
    emits: ['input'],
    props: {
      volumeValue: {
        type: Number,
        default: 0,
      },
      id: {
        type: String,
        default: '',
      },
      isDisable: {
        type: Boolean,
        default: false,
      },
    },
    setup(props, { emit }) {
      const input = ref<HTMLElement | null>(null);

      const getStyle = (colorValue: string) => {
        if (!input.value) return;
        input.value.style.background = `linear-gradient(to right, var(--active-color) 0%, var(--active-color) ${
          colorValue * 100
        }%, var(--sui-gray-500) ${colorValue * 100}%, var(--sui-gray-500) 100%)`;
      };

      const getProgress = () => {
        getStyle(props.volumeValue);
      };

      const getRange = () => {
        getStyle(input.value.value);
        emit('input', input.value.value);
      };

      watch(
        () => props.volumeValue,
        () => {
          getProgress();
        },
        {
          deep: true,
        }
      );

      onMounted(() => {
        getProgress();
      });
      return { input, getRange };
    },
  });
